var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconPinterestFollowUs = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27.16 35",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.07,24.63c-1.12,3.6-2.36,7.31-4.84,10.2a.46.46,0,0,1-.62.09.69.69,0,0,1-.7-.67A45.28,45.28,0,0,1,6.67,18.8a29.48,29.48,0,0,1,1-2.81C6.79,13.8,7,11.17,9,9.6c1.7-1.29,4-1.1,4.65,1.09.82,2.61-.06,6-1,9.09.43.24.78.57,1.25.81a4.31,4.31,0,0,0,3.85.09A4.13,4.13,0,0,0,18.82,20a9.45,9.45,0,0,0,1.58-2.65c.17-.49.31-1,.46-1.53A8.35,8.35,0,0,0,15.09,5.9c-3.41-1-7.46-.45-9.48,2.77-1.4,2.21-1.34,4.64-1,7.07a4.66,4.66,0,0,1,.64,2.87,1.66,1.66,0,0,1-.24.48,2,2,0,0,1-2.67.17,3,3,0,0,1-.79-1C-1.78,15,.88,7.66,3.41,4.7a14.1,14.1,0,0,1,17.28-3c5.68,3.06,8,11,5.45,16.91C23.83,24,16.42,27.41,11.07,24.63Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPinterestFollowUs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-pinterest-follow-us.818153d6.svg";
export { ForwardRef as ReactComponent };